import moment from 'moment';
import { twMerge } from 'tailwind-merge';
import {
    getCallRecordDisplayTimestamp,
    getUserFriendlyCallTypeTranslation,
} from 'flow/utils/call-record-utils';
import { callRecordIsMissed } from 'flow/utils/call-records-utils';
import CallRecordTypeIcon from 'flow/components/custom-components/CallRecordTypeIcon';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectCallRecordFromKey } from 'flow/selectors/call-selectors';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { PageType } from 'flow/components/call-history-v2/types';

interface Props {
    callRecordKey: CallRecordKey;
    pageType?: PageType;
}

const SectionCallType = ({ callRecordKey, pageType }: Props) => {
    const { i18next } = useAppContext();
    const callRecord = useAppSelector((state) =>
        selectCallRecordFromKey(state, callRecordKey),
    );

    if (!callRecord) return null;

    const callTypeKey = getUserFriendlyCallTypeTranslation(callRecord);
    const callTypeLabel = i18next.t(callTypeKey);
    const callIsMissed = callRecordIsMissed(callRecord);

    const timeLabel = moment(
        getCallRecordDisplayTimestamp(callRecord, pageType),
    ).format('HH:mm');

    return (
        <div className="flex items-center px-3">
            <CallRecordTypeIcon
                callRecordKey={callRecordKey}
                className="size-4"
                size="1rem"
            />
            <span
                className={twMerge(
                    'text-sm font-bold antialiased',
                    callIsMissed && 'text-red',
                )}
            >
                {callTypeLabel}
            </span>
            <span className="flex-1" />
            <span className="text-sm text-gray-500 antialiased">
                {timeLabel}
            </span>
        </div>
    );
};

export default SectionCallType;
